export const UP = 38;
export const DOWN = 40;
export const ENTER = 13;
export const ESC = 27;
export const TAB = 9;
export const PERIOD = 190;
export const SPACE = 32;
export const DASH = 189;
